<template>
    <div class="listmain ">
        <h1 class="firTitle">风向的控制</h1>

        <highlight-code lang="javascript">
            {
            "header":{
                "namespace":"Orion.Iot.Device.Control",
                "name":"SetWindDirection",
                "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
                "payLoadVersion":1
            },
            "payload":{
                "accessToken":"access token",
                "deviceId":"abcde12345",
                "deviceType":"fan",
                "attribute":"winddirection",
                "value":"auto",
                "extensions":{
                    "extension1":"",
                    "extension2":""
                }
            }
            }
        </highlight-code>
        <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
            <tbody>
            <tr>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                   value
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    说明
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    auto
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    自动
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    updown
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    上下摆风
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    leftright
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    左右摆风
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    up
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    向上摆风
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    down
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    向下摆风
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    left
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    向左摆风
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    right
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    向右摆风
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    forward
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    向前摆风
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    back
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:middle;">
                    向后摆风
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/equipmentControl/Zn_sb_fx.vue